import { Button, IconButton, makeStyles, Zoom } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React from "react";
import Dropzone from "react-dropzone";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

const stylesUse = makeStyles(theme => ({
    imageStyle: {
        maxWidth: "100%",
        height: "auto",
        objectFit: "contain",
    },
}));
/**
 *
 * @param previewImages required  { id: "", name: "", src: "" }
 * @returns
 */
export default function UploadfileImage({
    emptyImg = toAbsoluteUrl("/media/HCH/imgs/no-image-sm.png"),
    removeButton = true,
    classContainer = "",
    classPreview = "",
    classActions = "",
    classImg = "",
    previewImages = [],
    onAcceptedFiles = () => {},
    removeFile = () => {},
    removeAll = () => {},
    multiple = false,
    maxFiles = 1,
    error = "",
    hiddenButton = false,
}) {
    const classuse = stylesUse();
    return (
        <div className={classContainer ? classContainer : "row"}>
            {/* Preview images */}
            <div className={classPreview ? classPreview : "col-12 mb-5"}>
                {previewImages.length > 0 ? (
                    previewImages.map((file, idx) => (
                        <Zoom key={file.id} in={true} style={{ transition: idx + "00ms" }}>
                            <div className="position-relative">
                                {removeButton ? (
                                    <IconButton
                                        size="small"
                                        onClick={() => removeFile(file)}
                                        className="btn-remove-file text-danger position-absolute"
                                        style={{ right: 10, top: 10 }}>
                                        <Close fontSize={"default"} color="inherit" />
                                    </IconButton>
                                ) : null}
                                <img
                                    src={file.src}
                                    alt={file.name}
                                    className={classImg ? classImg : classuse.imageStyle}
                                />
                            </div>
                        </Zoom>
                    ))
                ) : (
                    <Zoom in={true} style={{ transition: "300ms" }}>
                        <img src={emptyImg} alt="empty" className={classImg ? classImg : classuse.imageStyle} />
                    </Zoom>
                )}
            </div>
            {/* actions upload */}
            <div className={classActions ? classActions : "col-12 mb-5"}>
                <Dropzone
                    onDrop={acceptedFiles => onAcceptedFiles(acceptedFiles)}
                    multiple={multiple}
                    maxFiles={maxFiles}
                    accept={{ "image/*": [] }}>
                    {({ getRootProps, getInputProps }) => (
                        <>
                            {hiddenButton === false ? (
                                <section className="d-flex align-items-center mb-2">
                                    <input {...getInputProps()} />
                                    <Button {...getRootProps()} className="btn t-btn-primary mr-2" component="span">
                                        <i className="fas fa-file-image mr-1" style={{ color: "inherit" }}></i>
                                        Upload
                                    </Button>
                                    <Button
                                        className="btn t-btn-gray"
                                        component={"span"}
                                        onClick={() => removeAll(previewImages)}>
                                        <i className="fas fa-trash-alt mr-1" style={{ color: "inherit" }}></i>Remove
                                    </Button>
                                </section>
                            ) : null}

                            <div className="text-danger">{error}</div>
                        </>
                    )}
                </Dropzone>
            </div>
        </div>
    );
}
